export const LastUpdated = '15 Septembre 2026';
